import { useEffect, useMemo, useRef } from 'react';
import { autoUpdate, useFloating } from '@floating-ui/react';
import { UITourPulserAnimate } from './UITourPulserElements';
import { PulserSpotlight } from './PulserSpotlight';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const pulserRects = {
  name: 'rects',
  fn({
    x,
    y,
    rects
  }) {
    return {
      x,
      y,
      data: Object.assign({}, rects.reference, {
        x,
        y
      })
    };
  }
};
const UITourPulserSpotlight = ({
  className,
  borderColor,
  borderSize,
  borderShadowId,
  enableBorder,
  pulserDistance,
  pulserDuration,
  pulserPadding,
  pulserRadius,
  pulserRef,
  pulserTarget
}) => {
  const {
    refs,
    middlewareData
  } = useFloating({
    elements: {
      reference: pulserTarget
    },
    placement: 'top-start',
    middleware: [pulserRects],
    whileElementsMounted: autoUpdate
  });
  const {
    x = 0,
    y = 0,
    width = 0,
    height = 0
  } = (middlewareData === null || middlewareData === void 0 ? void 0 : middlewareData.rects) || {};
  const pulserPathOptions = useMemo(() => ({
    distance: pulserDistance,
    padding: pulserPadding,
    radius: pulserRadius,
    targetRect: {
      x,
      y,
      width,
      height
    }
  }), [x, y, width, height, pulserDistance, pulserPadding, pulserRadius]);
  const prevPulserPathRef = useRef();
  const pulserPath = useMemo(() => {
    var _pulserRef$current, _pulserRef$current$re;
    const prevPulserPath = prevPulserPathRef.current;
    const newPulserPath = PulserSpotlight.generatePulserPath(pulserPathOptions);
    (_pulserRef$current = pulserRef.current) === null || _pulserRef$current === void 0 || (_pulserRef$current$re = _pulserRef$current.repositionPulserOverlay) === null || _pulserRef$current$re === void 0 || _pulserRef$current$re.call(_pulserRef$current, newPulserPath, prevPulserPath);
    prevPulserPathRef.current = newPulserPath;
    return newPulserPath;
  }, [pulserPathOptions, pulserRef]);
  useEffect(() => {
    if (refs.reference.current !== pulserTarget) {
      refs.setPositionReference(pulserTarget);
    }
  }, [refs, pulserTarget]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("span", {
      ref: refs.setFloating
    }), enableBorder && pulserPath &&
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx("path", {
      className: className,
      d: pulserPath.start,
      fill: "none",
      filter: `url(#${borderShadowId})`,
      stroke: borderColor,
      strokeWidth: borderSize,
      children: pulserPath.end && /*#__PURE__*/_jsx(UITourPulserAnimate, {
        duration: pulserDuration,
        values: `${pulserPath.start};${pulserPath.end};${pulserPath.start}`
      })
    })]
  });
};
export default UITourPulserSpotlight;